<template>
    <div class="Firmware-version">
      <pageTitle v-bind="{ ...pT }" />
      <business-group
        ref="businessGroup"
        :tableConfig="{ ...tableConfig }"
        :formConfig="{ ...formConfig }"
      >
        <template slot="formSlot" slot-scope="formSlot">
          <a-form-item>
            <a-input
              placeholder="请输入vid"
              v-decorator="['vid']"
              style="width: 250px; margin-right: 10px; vertical-align: middle"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              placeholder="请输入pid"
              v-decorator="['pid']"
              style="width: 250px; margin-right: 10px; vertical-align: middle"
            />
          </a-form-item>
          
        </template>
        <template slot="formRight">
          <a-button type="primary" @click="add">新增</a-button>
        </template>
        <template slot="action" slot-scope="record">
          <a-button type="link" @click="edit(record)">编辑</a-button>
          <a-button type="link" @click="del(record)">删除</a-button>
        </template>
      </business-group>
      <a-modal
        :visible="visible"
        :title="title"
        destroyOnClose
        @ok="submitForm('ruleForm')"
        @cancel="resetForm('ruleForm')"
        :maskClosable="false"
      >
        <a-form-model
          ref="ruleForm"
          class="device_config_ruleForm"
          :model="ruleForm"
          :rules="rules"
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input type="hidden" v-model="ruleForm.id" />
          <a-form-model-item label="vid" prop="vid">
            <a-input   placeholder="请输入vid" v-model="ruleForm.vid"  showCount :maxlength="8" />
          </a-form-model-item>
          <a-form-model-item label="pid" prop="pid">
            <a-input   placeholder="请输入pid" v-model="ruleForm.pid" showCount :maxlength="8"  />
          </a-form-model-item>
          <a-form-model-item label="设备名" prop="deviceName">
            <a-input   placeholder="请输入设备名" v-model="ruleForm.deviceName"  :maxlength="16"  />
          </a-form-model-item>
          <a-form-model-item label="调用次数" prop="schedule">
            <a-input   placeholder="请输入schedule" v-model="ruleForm.schedule" showCount :maxlength="8"  />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </template>
  
  <script>
  import pageTitle from "@/components/business/pageTitle";
  import businessGroup from "@/components/business/businessGroup";
  import formTime from "@/components/business/Form/formTime";
  import formSkeleton from "@/components/business/Form/formSkeleton";
  import moment from "moment";
  import { formatToStr } from "@/utils/dateUtils";
  import { confirm, tips } from "@/utils/util";
  export default {
    components: {
      pageTitle,
      businessGroup,
      formTime,
      formSkeleton
    },
    name: "audio-device-config",
    created() {
    },
    data() {
      let validatePass = (rule, value, callback) => {
        if (value === "" || value === undefined) {
          callback(new Error("不能为空"));
        } else {
          callback();
        }
      };
  
      let checkInput = (rule, value, callback) => {
          const regex = /[0-9]+/;
          if (value === "" || value === undefined) {
            callback(new Error("不能为空"));
          }else if(!regex.test(value)){
            callback(new Error("只能输入数字"));
          } else {
            callback();
          }
        };
  
      return {
        upLoading: false,
        files: [],
        dateFormat: this.$root.$data.dateFormat,
        nowTitleIsNew: false, //当前弹窗类型
        fileName: "",
        title: undefined,
        pT: {
          pageTitle: "麦克风设备号管理",
          // headerTitle: "更新时间",
          // text: "(单次操作不超过1年)"
        },
        tableConfig: {
          url: "bluetoothlight/web/router/neewerview/manage/audio/list",
          columns: [
            {
              title: "ID",
              dataIndex: "id",
              key: "id",
              align: "center",
            },
            {
              title: "vid",
              dataIndex: "vid",
              key: "vid",
              align: "center",
            },
            {
              title: "pid",
              dataIndex: "pid",
              key: "pid",
              align: "center"
            },
            {
              title: "设备名称",
              dataIndex: "deviceName",
              key: "deviceName",
              align: "center"
            },
            {
              title: "调用次数",
              dataIndex: "schedule",
              key: "schedule",
              align: "center"
            },
            {
              title: "操作",
              align: "center",
              width: 150,
              scopedSlots: { customRender: "action" },
            }
          ],
          rowKey: "ID",
        },
        formConfig: {
          timeShow: false,
          formShow: true,
        },
        pageLoading: false,
        loading: false,
        visible: false,
        ruleForm: {
          // packageSize 默认为禁用 文件上传成功之后回显
        },
        rules: {
          vid: [
            { required: true, validator: checkInput, trigger: "change", message: "vid不能为空" },
          ],
          pid: [
            { required: true, validator: checkInput, trigger: "change", message: "pid不能为空" }
          ],
          deviceName: [
            { required: true, validator: validatePass, trigger: "change", message: "设备名称不能为空" }
          ],
          schedule: [
            { required: true, validator: checkInput, trigger: "change", message: "调用次数不能为空" }
          ]
        },
        refresh: false,
        upUserList: [],
      };
    },
    methods: {
      moment,
      dataFormatStr(ret,format){
        if(!ret){
            return "";
        }
        if(!format){
            format = "YYYY-MM-DD HH:mm:ss";
        }
        return formatToStr(ret,format)
      },
      add() {
        this.title = "新增";
        this.visible = true;
        this.nowTitleIsNew = true;
      },
      // 编辑  deviceModel 转了 number
      edit: async function (record) {
        this.ruleForm = { ...record};
        this.title = "编辑";
        this.visible = true;
      },
      // 删除  关键词  rowKey
      del(record) {
        const id = record?.id;
        if (!id || this.pageLoading) return false;
        this.pageLoading = true;
        const payload = {
          okBack: async () => {
            const res = await this.$http(
              "POST",
              `bluetoothlight/web/router/neewerview/manage/audio/delete/${id}`
            );
            const errorCode = res?.errorCode;
            if (errorCode=="0") {
              tips(this, true);
              this.refreshData();
            }
          },
          title: `是否删除该配置`
        };
        confirm(this, payload);
        this.pageLoading = false;
      },
      // 验证表单和提交数据
      submitForm(formName) {
        if (!formName) return false;
        this.$refs[formName].validate(async (valid) => {
          if (!valid) return false;
          let res;
          res = await this.$post(
                `bluetoothlight/web/router/neewerview/manage/audio/save`,
                {
                  ...this.ruleForm
                }
            );
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.visible = false;
            this.refreshData();
            this.resetForm("ruleForm");
          }
        });
      },
      // 重置表单和隐藏 modal
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.visible = false;
        this.ruleForm = {};
        this.files = [];
      },
      // 刷新table数据
      refreshData() {
        this.$refs?.["businessGroup"]?.getData?.();
      },
  
      cancel(cancel) {
        return cancel;
      },
      remove() {
        this.ruleForm.url = undefined;
        this.files = [];
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .m-upload {
    .ant-upload-select {
      width: 60px;
      height: 60px;
      border: 1px solid #c3c3c3;
      text-align: center;
      line-height: 60px;
    }
  
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }
  
    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
  
  .device_config_ruleForm {
    width: 380px;
    margin: 0 auto;
  
    .ant-form-item-children,
    .ant-calendar-picker {
      width: 100%;
    }
  }
  </style>
  